import { LANGUAGE_LOADED } from "../infrastructure/actions";

export const loadLanguage = (culture, dispatch) => {
  const getJson = (f) => {
    return fetch(f).then((x) => x.json());
  };

  const merge = (o, rest) => {
    var next = rest.pop();
    if (!next) return o;

    const merged = {
      ...o,
      ...next,
    };

    return merge(merged, rest);
  };

  const generalUri = process.env.PUBLIC_URL + `/language.${culture}.json`;
  const specificUri = `/ee-static/members/language/language.${culture}.json`;

  const files = [specificUri, generalUri].map((f) => getJson(f));

  Promise.all(files)
    .then((response) => merge({}, response))
    .then((json) => {
      dispatch({
        type: LANGUAGE_LOADED,
        payload: json,
      });
    });
};
